import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import slugify from "react-slugify"

const Footer = () => {
    const data = useStaticQuery(graphql`
    query CityListQuery {
          allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "city-pages"}}}) {
              edges {
                  node {
                  frontmatter {
                      title
                  }
                }
            }
          }
      }
  `)
    return (
        <div className="max-w-7xl mx-auto px-4">
            <div className="bg-neutral-700 w-full pt-2 lg:px-10 px-4 pb-4">
                <div className="text-center">
                    <h2 className="text-white md:text-2xl text-lg mb-2 bg-[url('../assets/images/fheader_bg.png')] bg-no-repeat bg-bottom pb-3 mb-6">Vinyl Decks City Pages</h2>
                </div>
                <ul className="m-0 p-0 flex flex-wrap">
                    {data.allMarkdownRemark.edges.map((item, index) => {
                        const slug = `vinyl-deck-wood-deck-${slugify(item.node.frontmatter.title)}`.toLowerCase();
                        return (
                            <li key={index} className="lg:w-1/4 md:w-2/6 sm:w-3/6 w-full mb-2"><Link to={`/${slug}`} className="text-white font-light text-sm font1 no-underline flex items-center gap-2"><svg className="rotate-45" xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="#fff" viewBox="0 0 24 24"><path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z" /></svg> {item.node.frontmatter.title}</Link></li>
                        )
                    })}

                </ul>
            </div>
            <div className="bg-teal-600 p-5 lg:px-10 px-4">
                <div className="flex flex-row gap-4 md:flex-row flex-col items-center justify-between">
                    <p className="text-white text-sm m-0 lg:w-1/2 md:w-2/6 ">© {new Date().getFullYear()}</p>
                    <p className="mb-0"><svg clip-rule="evenodd" width="15" fill-rule="evenodd" height="15" stroke-linejoin="round" fill="#fff" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m18.787 9.473s-4.505-4.502-6.259-6.255c-.147-.146-.339-.22-.53-.22-.192 0-.384.074-.531.22-1.753 1.753-6.256 6.252-6.256 6.252-.147.147-.219.339-.217.532.001.19.075.38.221.525.292.293.766.295 1.056.004l4.977-4.976v14.692c0 .414.336.75.75.75.413 0 .75-.336.75-.75v-14.692l4.978 4.978c.289.29.762.287 1.055-.006.145-.145.219-.335.221-.525.002-.192-.07-.384-.215-.529z" fill-rule="nonzero" /></svg></p>
                </div>
            </div>
        </div>
    )
}
export default Footer